import * as React from 'react';
import {
  GridColumnMenuSort,
  GridColumnMenuFilter,
  GridColumnMenuItemGroup,
  GridColumnMenuItem,
  GridColumnMenuGroup,
  GridColumnMenuItemContent,
} from '@progress/kendo-react-grid';
import { CustomColumnMenuFilter } from './custom-column-menu-filter';

export const ColumnMenu = (props: any) => {
  const [columns, setColumns] = React.useState(props.columns);
  const [columnsExpanded, setColumnsExpanded] = React.useState(false);
  const [filterExpanded, setFilterExpanded] = React.useState(false);
  const onToggleColumn = (id: any) => {
    const newColumns = columns.map((column: any, idx: number) => {
      return idx === id
        ? {
            ...column,
            columnShow: !column.columnShow,
          }
        : column;
    });
    setColumns(newColumns);
  };
  const onReset = (event: any) => {
    event.preventDefault();
    const newColumns = props.columns.map((col: any) => {
      return {
        ...col,
        columnShow: true,
      };
    });
    setColumns(newColumns);
    props.onColumnsSubmit(newColumns);
    if (props.onCloseMenu) {
      props.onCloseMenu();
    }
  };

  const onSubmit = (event: any) => {
    if (event) {
      event.preventDefault();
    }
    props.onColumnsSubmit(columns);
    if (props.onCloseMenu) {
      props.onCloseMenu();
    }
  };

  const onMenuItemClick = () => {
    const value = !columnsExpanded;
    setColumnsExpanded(value);
    setFilterExpanded(value ? false : filterExpanded);
  };
  const onFilterExpandChange = (value: any) => {
    setFilterExpanded(value);
    setColumnsExpanded(value ? false : columnsExpanded);
  };
  const oneVisibleColumn = columns.filter((c: any) => c.columnShow).length === 1;

  return (
    <div>
      <GridColumnMenuSort {...props} />
      <GridColumnMenuFilter {...props} onExpandChange={onFilterExpandChange} expanded={filterExpanded} />
      {/* <CustomColumnMenuFilter {...props} onExpandChange={onFilterExpandChange} expanded={filterExpanded} /> */}

      <GridColumnMenuItemGroup>
        <GridColumnMenuItem title={'Columns'} iconClass={'k-i-columns'} onClick={onMenuItemClick} />
        <GridColumnMenuItemContent show={columnsExpanded}>
          <div className={'k-column-list-wrapper'}>
            <form>
              <div className={'k-column-list'}>
                {columns.map(
                  (column: any, idx: number) =>
                    !column?.hide && (
                      <div key={idx} className={'k-column-list-item'}>
                        <span>
                          <input
                            id={`column-visiblity-show-${idx}`}
                            className="k-checkbox k-checkbox-md k-rounded-md"
                            type="checkbox"
                            readOnly={true}
                            disabled={column.columnShow && oneVisibleColumn}
                            checked={column.columnShow}
                            onClick={() => {
                              onToggleColumn(idx);
                            }}
                          />
                          <label
                            htmlFor={`column-visiblity-show-${idx}`}
                            className="k-checkbox-label"
                            style={{
                              userSelect: 'none',
                            }}
                          >
                            {column.title}
                          </label>
                        </span>
                      </div>
                    )
                )}
              </div>
              <div className={'k-actions k-hstack k-justify-content-stretch'}>
                <button
                  type={'button'}
                  onClick={onReset}
                  className={'k-button k-button-md k-rounded-md k-button-solid k-button-solid-base'}
                >
                  Reset
                </button>
                <button
                  type="button"
                  onClick={onSubmit}
                  className={'k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary'}
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </GridColumnMenuItemContent>
        <GridColumnMenuGroup {...props} />
      </GridColumnMenuItemGroup>
    </div>
  );
};
